import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { getDriverScoreDay } from '../../services/DriversService';
import { DriverScoreDay } from '../../types/Drivers';
import { FeaturesManagement } from '../../../featuresControl';

function useGetDriverScoreDay(
  id: string,
  fleetId: string,
  date: string,
): UseQueryResult<DriverScoreDay> {
  return useQuery(
    ['driver-score-day', id, fleetId, date],
    async (): Promise<DriverScoreDay> => getDriverScoreDay(id, fleetId, date),
    {
      retry: 1,
      retryDelay: 3000,
      keepPreviousData: true,
      refetchInterval: FeaturesManagement.productivity.refetchInterval,
      enabled: !!id && !!date,
    },
  );
}

export default useGetDriverScoreDay;
